import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconLogOutProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconLogOut: React.FC<IconLogOutProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Log out',
}) => {
    return (
        <IconBase color={color} size={size} className={className} title={title}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="m16 17 5-5-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 12H9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </IconBase>
    );
};

export default IconLogOut;
